// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3s-yw","modalControls":"yhnG-","deleteBtnWrapper":"o4rHQ"};